import React, {ReactNode} from "react";
import {clampLines} from "../../utils/textClamp";
import {appRoute} from "../../utils/routes";
import {Resource, ResourceType, resourceTypeIconMap} from "../../models/resource";
import {Avatar, Box, Button, Card, Chip, IconButton, Stack, Typography} from "@mui/joy";
import {Link} from "react-router-dom";
import {normalizeCategoryName} from "../../utils/normalizeCategoryName";

type ResourceItemComponentProps = {
    resource?: Resource
}

const ResourceItemComponent = (props: ResourceItemComponentProps) => {

    return <Link to={appRoute(`resources?type=lesson&view=resource&resourceId=${props.resource.id}`)} style={{textDecoration: "none"}}>
        <Card data-no-animation data-border-focus
              sx={{
                  padding: 3,
                  transition: "transform 0.3s ease",
              }}>

            <Stack direction="row" gap={2}>
                <Box data-accent width={"max-content"} display={"flex"}
                     alignItems="center"
                     padding={1} height={"max-content"} sx={{
                    bgcolor: "primary.softBg",
                    color: "primary.softColor"
                }} borderRadius={10}>
                    {resourceTypeIconMap[props.resource.type]}
                </Box>

                <Stack gap={2} justifyContent={"space-between"} flex={1} minWidth={0}>
                    <Typography level={"h4"} title={props.resource.title} sx={clampLines(2)}>
                        {props.resource.title}
                    </Typography>

                    <Stack gap={1} direction={"row"} alignItems={"center"} flexWrap={"wrap"}>

                        <Chip color={"primary"} sx={{textTransform:"capitalize"}}>
                            {props.resource.type}
                        </Chip>

                        {props.resource.examRelevance?.map(exam =>
                            <Chip color={"primary"}>
                                {exam}
                            </Chip>)}

                        {props.resource.category?.map(category =>
                            <Chip color={"secondary"}>
                                {normalizeCategoryName(category)}
                            </Chip>)}


                        <Typography>
                            {props.resource.readCount || 0} Reads
                        </Typography>
                    </Stack>

                </Stack>
            </Stack>


        </Card>
    </Link>
}

export default ResourceItemComponent